/**
 * CORE-1448 — первая фраза, которую гость видит, открыв разговор с Агапеллой
 * на публичной странице.
 *
 * Отдельным модулем, а не внутри секции: это копирайт, его читают и правят
 * отдельно от вёрстки, и его проверяет тест — а секция тянет за собой весь
 * чат.
 *
 * Модель для приветствия не зовётся: платить за «привет» из бюджета, ради
 * ограничения которого всё делается, незачем.
 *
 * Текст мой. Продукт не ответил на вопрос о приветствии за неделю, и ждать
 * дороже, чем поменять строку потом. Тон взят у трёх приглашений, которые
 * пишет сервер на исчерпанный лимит: тёплое «ты», без восклицательных знаков,
 * с приглашением спросить, а не с рассказом о себе.
 *
 * Числа в тексте нет намеренно: остаток ходов знает сервер, клиенту он в
 * потоке ответа не приходит, и называть его здесь значило бы врать в мелочи,
 * которую человек проверит на шестом сообщении.
 */
export const GUEST_GREETING =
  'Привет ✦ Я Агапелла. Могу рассказать, что здесь есть, и помочь выбрать, '
  + 'с чего начать — спроси о чём угодно.';
